<template>
  <div class="post-info">
    <el-table class="list" :data="memberList">
      <el-table-column prop="avatar" label="头像" width="150" align="center">
        <template slot-scope="scope">
          <el-image
            :src="scope.row.avatar"
            style="width: 44px; height: 44px"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="nickName" label="姓名" align="center">
      </el-table-column>
      <el-table-column prop="sno" label="学号" align="center">
      </el-table-column>
      <el-table-column prop="post" label="职位" align="center">
      </el-table-column>
      <el-table-column
        prop="status"
        label="审核状态"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 'RESOLVE'" style="color: #6ce115"
            >已通过</span
          >
          <span v-if="scope.row.status == 'PENDING'" style="color: #ffc55f"
            >审核中</span
          >
          <span v-if="scope.row.status == 'REJECT'" style="color: #f56c6c"
            >已拒绝</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="加入日期" align="center">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { memberList } from "@/api/team";
export default {
  data() {
    return {
      memberList: [],
    };
  },
  created() {
    this.getMemberList();
  },
  methods: {
    // 团队成员
    getMemberList() {
      this.$loading.show();
      memberList(this.$route.query.id).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.memberList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.post-info {
  ::v-deep .list {
    .is-leaf {
      color: #333;
      background-color: #f5f5f5;
    }
  }
}
</style>